import { defineComponent, ref, onMounted, onBeforeUnmount } from 'vue';
import { useRoute } from 'vue-router';
import { DateHelper, useSiteDeviceGenType, useSiteId, useSiteInfo } from '@hems/util';
import { NUMBER_UNIT, SITE_STATUS_CODE_MAP } from '@hems/util/src/constant';
import { getRouteInfo, isSiteStatusCodeType, isStringType } from '@hems/util/src/helper/tsguardHelper';
export default defineComponent({
    name: 'MonitoringDetailsHeader',
    setup() {
        const { isAC } = useSiteDeviceGenType();
        const { siteId } = useSiteId();
        const { masterDeviceProfile } = useSiteInfo();
        const timezoneId = masterDeviceProfile?.timezone_id;
        const route = useRoute();
        const statusId = getRouteInfo(route.query.statusId, isStringType);
        const statusCode = statusId?.charAt(0) ?? '';
        const statusValue = isSiteStatusCodeType(statusCode) ? SITE_STATUS_CODE_MAP[statusCode] : '';
        const statusIndex = Object.entries(SITE_STATUS_CODE_MAP).findIndex(([, value]) => value === statusValue) + 1;
        const getLocalTime = () => DateHelper.getLocalDate(DateHelper.now(), {
            isTime: true,
            needTimezoneConvert: true,
            timezone: timezoneId,
        });
        const localTime = ref(getLocalTime());
        const updateTime = () => {
            localTime.value = getLocalTime();
        };
        let intervalId;
        onMounted(() => {
            intervalId = setInterval(updateTime, NUMBER_UNIT.THOUSAND);
        });
        onBeforeUnmount(() => clearInterval(intervalId));
        return {
            siteId,
            isAC,
            timezoneId,
            localTime,
            statusId,
            statusValue,
            statusIndex,
        };
    },
});
